module.exports = __webpack_public_path__ + "media/demo2-kr.eab8a6e0.mp4";